import React from 'react';

import { substituteMergeTags } from './mergeTags';

interface ComponentProps {
  value: { subject?: string; body?: string };
  onChange?: (name: string, value: any) => void;
}

const EmailPreview: React.FC<ComponentProps> = ({ value }) => {
  const previewSubject = substituteMergeTags(value?.subject ?? '');
  const previewBody = substituteMergeTags(value?.body ?? '');

  return (
    <div>
      <h6 className="fw-semibold text-muted mb-2">Preview (with example values)</h6>
      <div className="border rounded p-3 bg-white">
        <div className="mb-2">
          <span className="fw-semibold text-muted small">Subject:</span>
          <div>
            {previewSubject || <span className="text-muted fst-italic">No subject entered</span>}
          </div>
        </div>
        <div>
          <span className="fw-semibold text-muted small">Body:</span>
          <pre className="bulk-signup-email-body mb-0">
            {previewBody || <span className="text-muted fst-italic">No body entered</span>}
          </pre>
        </div>
      </div>
    </div>
  );
};

export default EmailPreview;
